import { createContext } from "react";
export const ReasonContext = createContext({});
